
<div class="modal-dialog confirm-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Registration Link</h5>
      <button class="close" type="button" (click)="closeDialog()">&times;</button>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <textarea class="form-control" [(ngModel)]="registrationLink" name="registrationLink" readonly rows="6"></textarea>
    </div>
    <div class="modal-footer"><span *ngIf="emailSentMessage">Email Sent</span>
      <button class="btn btn-outline-secondary" type="button" (click)="sendWelcomeEmail()" [disabled]="disableButtons"><span class="oi oi-envelope-closed"></span>&nbsp; Send Welcome Email</button>
      <button class="btn btn-outline-secondary" type="button" (click)="closeDialog()" [disabled]="disableButtons">Close</button>
    </div>
  </div>
</div>